<!--
 * @Description: 服务事项配置模板新增组dialog组件
 * @Author: sunhuihong
 * @Date: 2022-03-29 14:43:52
 * @LastEditTime: 2022-11-25 15:25:37
-->
<template>
  <el-dialog width="640px" :title="dialogTitle" :visible.sync="showAddGroupDialog" :close-on-click-modal="false"
    @open="initGroupData" :before-close="handleCancel" center>
    <el-form class="form" ref="groupFrom" :model="groupFrom"  label-width="120px">
      <el-form-item prop="name" label="名称" :rules="[
         { required: true, message: '请输入组名称', trigger: 'blur' },
         { min:1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'change'
        }]">        
        <el-input size="small"  v-model.trim="groupFrom.name" maxlength="10" placeholder="请输入组名称" 
          autocomplete="off" style="width: 320px">
        </el-input>  
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleGroupFormSubmit('groupFrom')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: "AddMatterCfgGroupDialog",
  props: ["showAddGroupDialog", "mode","serviceItemId"],
  data() {
    return {
      groupFrom: {},
    };
  },

  computed: {
    dialogTitle() {
      switch (this.mode) {
        case 'add'    : return "新增组名称";
        case 'edit'   : return "编辑组名称";
        default       : return "----";
      } 
    }
  },

  methods: {
    //获取编辑接口数据
    initGroupData() {
      if (this.mode == "edit") {
        let params = {id: this.serviceItemId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_MATTER_CFG,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.groupFrom = result.data;
          }
        });
      }
    },

    //清空
    clearGroupFormData() {
      this.groupFrom = {};
      this.$nextTick(() => {
        this.$refs["groupFrom"].clearValidate();
      });
    },

    //确定提交表单接口调用
    handleGroupFormSubmit(groupFrom) {
      this.$refs[groupFrom].validate((valid) => {
        if (!valid) return false;
        let url = this.mode == 'add' ? Constant.URL_SAVE_MATTER_CFG : Constant.URL_UPDATW_MATTER_CFG;
        let method = this.mode == 'add' ? 'POST' : 'PUT';
        this.groupFrom.parentId = 0;
        let header = this.encryptionUtil.signatureBody(this.groupFrom,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: this.groupFrom,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.$emit('add-group-data',this.groupFrom);
            this.clearGroupFormData();
            this.$emit("handle-close-group-dialog", true);
          }
        });
      });
    },

    handleCancel() {
      this.clearGroupFormData();
      this.$emit("handle-close-group-dialog", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hsvccfg/components/matterCfgDetails/AddMatterCfgGroupDialog.vue